export default "__VITE_ASSET__D_fbt_Db__"